import { Breadcrumb, IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import * as React from 'react';
import { connect } from 'react-redux';
import { /* RouteComponentProps, */ withRouter } from 'react-router-dom';
import { IRootState } from '../../redux/Reducers/RootReducer';
import './BreadCrumbs.css';

/* export interface IBreadCrumbsProps extends RouteComponentProps<any> {
  items?: IBreadcrumbItem[]
}; */

function mapStateToProps(state: IRootState, ownProps: any) {
  return { items: state.breadCrumbsState.items };
}

class BreadCrumbs extends React.PureComponent<any, any> {
  public render(): JSX.Element {
    if (this.props.items) {
      this.props.items.forEach((item: any) => {
        item.onClick = this.onBreadcrumbItemClicked;
      });
      return <Breadcrumb items={this.props.items} className="BreadCrumbs" styles={{ root: { margin: 0 } }} />;
    } else {
      return <h4>loading...</h4>;
    }
  }

  private onBreadcrumbItemClicked = (ev: React.MouseEvent<HTMLElement>, item: IBreadcrumbItem): void => {
    console.log(`Breadcrumb item with key "${item.key}" has been clicked.`);
    this.props.history.push(`${item.key}`);
  };
}

export default withRouter(connect(mapStateToProps)(BreadCrumbs) as any);
